<template>
    <div class="q-summit-sidebar-header" :class="{ 'q-summit-sidebar-header--mobile': $vuetify.breakpoint.smAndDown }">
        <QSummitSidebarHeaderBackground class="q-summit-sidebar-header__background" />
        <div class="q-summit-sidebar-header__compass">
            <QCompassProgress :currentStep="currentStep" :totalSteps="totalSteps" />
        </div>
        <div class="pt-8 d-flex justify-end q-summit-sidebar-home-btn">
            <v-btn to="/summit" color="primary" icon size="small">
                <v-icon>fas fa-home</v-icon>
            </v-btn>
        </div>
        <div class="d-flex px-4" :class="{ 'justify-end': $vuetify.breakpoint.smAndDown, 'justify-center': !$vuetify.breakpoint.smAndDown }">
            <div>
                <h6 class="q_green_1--text text-uppercase">Summit</h6>
                <h3 class="q-summit-sidebar-header__step-category">
                    {{ stepCategory }}
                </h3>
            </div>
        </div>
    </div>
</template>
<script>
import QCompassProgress from "../QCompassProgress.vue"
import QSummitSidebarHeaderBackground from "./QSummitSidebarHeaderBackground.vue"

export default {
    components: { QCompassProgress, QSummitSidebarHeaderBackground },

    props: {
        stepCategory: { type: String, default: "Activate" },
        totalSteps: { type: Number, required: true },
        currentStep: { type: Number, required: true },
    },
}
</script>
<style lang="scss">
$headerTextColor: #FFFFFF;

.q-summit-sidebar-home-btn {
    position: relative;
    z-index: 2;
}

.q-summit-sidebar-header {
    min-height: 150px;
    position: relative;
    z-index: 5;

    &--mobile {
        .q-compass-percentage {
            height: 100%;
            transform: translateX(-25%) !important;
        }
    }

    h3 {
        margin: 0
    }

    &__background {
        position: absolute;
        bottom: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
    }

    &__compass {
        position: absolute;
        left: 0;
        height: 75%;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        z-index: 1;

        .q-compass-percentage {
            height: 100%;
            transform: translateX(-50%);
            z-index: 1;
        }
    }

    &__step-category {
        color: $headerTextColor;
        font: normal normal normal 40px/49px Montserrat;
        letter-spacing: 0px;
        font-weight: normal !important;
    }
}
</style>>